import React, { useState } from 'react';

const HeroSection = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    if (onSearch) {
      onSearch(searchQuery);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <section className="bg-slate-100 w-full">
      <div className="w-full px-4 sm:px-6 lg:px-6 xl:px-6 pt-20 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center max-w-screen-2xl mx-auto">
          <div className="flex flex-col gap-8 px-4 lg:px-0">
            <h1 className="text-slate-900 text-4xl sm:text-5xl font-semibold text-center lg:text-start leading-tight">
              Welcome to Learners Edge
            </h1>
            <h3 className="text-slate-700 text-lg text-center lg:text-start">
              A pioneering platform created for ambitious bankers seeking to propel their careers through competitive certification and promotion exams
            </h3>
            <div className="relative rounded-full">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={handleKeyPress}
                className="py-6 lg:py-8 pl-8 pr-20 text-lg w-full text-black rounded-full focus:outline-none shadow-lg"
                placeholder="Search courses..."
                autoComplete="off"
              />
              <button
                onClick={handleSearch}
                className="bg-blue-600 p-5 rounded-full absolute right-2 top-2 hover:bg-blue-700 transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="text-white text-4xl inline-block" width="1em" height="1em" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" strokeWidth="1.5">
                    <circle cx="11.5" cy="11.5" r="9.5"></circle>
                    <path strokeLinecap="round" d="M18.5 18.5L22 22"></path>
                  </g>
                </svg>
              </button>
            </div>
            <div className="flex items-center justify-center lg:justify-between flex-wrap gap-4 pt-4">
              <div className="flex gap-2 items-center">
                <img alt="check-image" width="30" height="30" className="w-7 h-7" src="/images/banner/check-circle.svg" />
                <p className="text-sm sm:text-lg font-normal text-black">Flexible</p>
              </div>
              <div className="flex gap-2 items-center">
                <img alt="check-image" width="30" height="30" className="w-7 h-7" src="/images/banner/check-circle.svg" />
                <p className="text-sm sm:text-lg font-normal text-black">Learning path</p>
              </div>
              <div className="flex gap-2 items-center">
                <img alt="check-image" width="30" height="30" className="w-7 h-7" src="/images/banner/check-circle.svg" />
                <p className="text-sm sm:text-lg font-normal text-black">Community</p>
              </div>
            </div>
          </div>
          <div className="flex justify-center lg:justify-end">
            <img alt="Learning illustration" width="1000" height="805" className="w-full max-w-xl lg:max-w-2xl" src="/images/banner/mahila.png" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
